"use strict";
function get(obj, path) {
    for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
        if (!obj) {
            return null;
        }
        obj = obj[path[i]];
    }
    return obj;
}
exports.get = get;
;
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ionic-native/dist/es5/util.js
// module id = 497
// module chunks = 0